import React, {Component} from "react";
import {applyRouterMiddleware, browserHistory, Redirect, Route, Router} from "react-router";
import {useScroll} from "react-router-scroll";
import Pricing from "./modules/views/Pricing";
import MocksProduct from "./modules/views/mocks/Product";
import Register from "./modules/views/Register";
import Login from "./modules/views/Login";
import Dashboard from "./modules/views/Dashboard";
import Subscription from "./modules/views/Subscription";
import Mock from "./modules/views/mocks/Mock";
import Logs from "./modules/views/Logs";
import Account from "./modules/views/Account";
import Terms from "./modules/views/legal/Terms";
import EULA from "./modules/views/legal/EULA";
import Privacy from "./modules/views/legal/Privacy";
import Docs from "./modules/views/docs/Index";
import DocsPlatform from "./modules/views/docs/Platform";
import About from "./modules/views/docs/about/About";
import Contact from "./modules/views/docs/about/Contact";
import Simple from "./modules/views/docs/mocks/Simple";
import Advanced from "./modules/views/docs/mocks/Advanced";
import DocsMockFAQ from "./modules/views/docs/mocks/FAQ";
import DocsMockAPI from "./modules/views/docs/mocks/API";
import Subscribe from "./modules/views/Subscribe";
import Samples from "./modules/views/docs/mocks/Samples";
import DocsMocksGettingStarted from "./modules/views/docs/mocks/GettingStarted";
import Mocks from "./modules/views/mocks/Mocks";

class MocksApp extends Component {
    logPageView = () => this.props.logPageView();
    requireAuth = (nextState, replace) => this.props.requireAuth(nextState, replace);

    render() {
        return (
            <Router history={browserHistory}
                    render={applyRouterMiddleware(useScroll())}
                    onUpdate={this.logPageView}>

                {/* Unauthenticated marketing */}
                <Route path="/" component={MocksProduct}/>
                <Route path="/pricing" component={Pricing}/>

                {/* Auth */}
                <Route path="/register" component={Register}/>
                <Route path="/login" component={Login}/>

                {/* Legal */}
                <Route path="/legal/terms" component={Terms}/>
                <Route path="/legal/license" component={EULA}/>
                <Route path="/legal/privacy" component={Privacy}/>

                {/* Docs */}
                <Route path="/docs" component={Docs}/>
                <Route path="/docs/platform" component={DocsPlatform}/>

                {/* Mock docs */}
                <Route path="/docs/mocks/api" component={DocsMockAPI}/>
                <Route path="/docs/mocks/faq" component={DocsMockFAQ}/>
                <Route path="/docs/mocks/getting-started" component={DocsMocksGettingStarted}/>
                <Route path="/docs/mocks/simple" component={Simple}/>
                <Route path="/docs/mocks/advanced" component={Advanced}/>
                <Route path="/docs/mocks/samples" component={Samples}/>

                {/* About docs */}
                <Route path="/docs/about" component={About}/>
                <Route path="/docs/about/contact" component={Contact}/>

                {/* Common authenticated */}
                <Route path="/dashboard" component={Dashboard} onEnter={this.requireAuth}/>
                <Route path="/subscription" component={Subscription} onEnter={this.requireAuth}/>
                <Route path="/subscribe" component={Subscribe} onEnter={this.requireAuth}/>
                <Route path="/logs" component={Logs} onEnter={this.requireAuth}/>
                <Route path="/account" component={Account} onEnter={this.requireAuth}/>

                {/* Mocks */}
                <Route path="/mocks" component={Mocks} onEnter={this.requireAuth}/>
                <Redirect from="/mocks/config" to="/mocks/default"/>
                <Route path="/mocks/:mockId" component={Mock} onEnter={this.requireAuth}/>
            </Router>
        );
    }
}

MocksApp.propTypes = {
    logPageView: React.PropTypes.func.isRequired,
    requireAuth: React.PropTypes.func.isRequired,
};

export default MocksApp;



// WEBPACK FOOTER //
// ./src/MocksApp.js